import { defineStore } from 'pinia';
import UiState from './state';
import { IStoreUiState } from './ui.interface';
import { _addVideo, _hasVideo } from './actions';

export const useUiStore = defineStore('ui', {
  state: (): IStoreUiState => ({ ...UiState }),
  actions: {
    addVideo(videoId: number) {
      _addVideo(this, videoId);
    },
    hasVideo(videoId: number): boolean {
      return _hasVideo(this, videoId);
    },
  },
});
